<template>
    <div class="privacyPassword">
        <div class="privacyPassword_first" v-if="routerState">
            <van-nav-bar
                :title="title"
                left-text=""
                class="main-nav"
                @click-left="onClickLeft"
            >
            <template #left>
                <van-icon color="#000" name="arrow-left" size="20" v-if="flag == 2" />
            </template>
            <template #right>
                <div v-if="flag==1 || flag ==0 || flag ==3" @click="goOnce">取消</div>
            </template>
            </van-nav-bar>
        </div>
        <div class="privacyPassword_center" v-if="flag==1 || flag ==0">
            <div class="privacyPassword_center_circleBox">
                <div :class="[firstList.length>0 || oldPassword.length>0  ?'active':'','privacyPassword_center_circle']"></div>
                <div :class="[firstList.length>1 || oldPassword.length>1 ?'active':'','privacyPassword_center_circle']"></div>
                <div :class="[firstList.length>2 || oldPassword.length>2 ?'active':'','privacyPassword_center_circle']"></div>
                <div :class="[firstList.length>3 || oldPassword.length>3 ?'active':'','privacyPassword_center_circle']"></div>
            </div>
            <p>{{text}}</p>
        </div>
        <div v-if="status == 3 || status == 4" class="forgetPwd" @click="handleGotoUpdatePwd">忘记密码？</div>
        <div class="privacyPassword_center" v-if="flag==2">
            <div class="privacyPassword_center_circleBox">
                <div :class="[secondList.length>0?'active':'','privacyPassword_center_circle']"></div>
                <div :class="[secondList.length>1?'active':'','privacyPassword_center_circle']"></div>
                <div :class="[secondList.length>2?'active':'','privacyPassword_center_circle']"></div>
                <div :class="[secondList.length>3?'active':'','privacyPassword_center_circle']"></div>
            </div>
            <p>{{text}}</p>
        </div>
        <div class="privacyPassword_center" v-if="flag==3">
            <van-field
                v-model="password"
                :type="passtype"
                name="oldPassword"
                maxlength='13'
                class="privacyPassword_center_pass"
            />
            <p>{{text}}</p>
            <div class="privacyPassword_center_button" @click="submit" v-if="!show" >
                确认
            </div>
        </div>
        <van-number-keyboard
            :show="show"
            :length="4"
            close-button-text=''
            extra-key
            @input="onInput"
            @delete="onDelete"
        />
    </div>
</template>
<script>
import {_setParentPassword,_checkParentPasswordEnable,_setStudentPassword,_checkStudentPasswordEnable} from '../../api/test-center'
// import {_login} from '../../api/login'
import { encryptBy,decryptBy } from '../../assets/js/encryption';
import {verticalScreen} from '../../assets/js/vertical-screen';
export default {
    name: "privacy-password",
    data() {
        return{
            title:'设置家长隐私密码',//页面名称
            text:'输入隐私密码',//输入密码话术
            show: true,//数字键盘是否出现
            firstList:[],//输入密码数组
            flag:1,//第一次和第二次输入密码标识
            secondList: [],//确认密码数组
            status: '',//家长与儿童标识
            oldPassword:[], //当前隐私密码
            passtype:'password',// 密码框状态
            password:'',
            phone:'',
            routerState: true,
            routerFrom: null
        }
    },
    mounted() {
        verticalScreen();
    },
    beforeRouteEnter(to,from,next) {
      next(vm => {
        vm.routerFrom = from;
      })
    },
    created() {
        this.init();
        // let a =JSON.parse(localStorage.getItem("userInfo"));
        let info = localStorage.getItem("userInfo")
        let user = JSON.parse(decryptBy(info));
        this.phone = decryptBy(user.mobilePhoneStr);
    },
    methods: {
      init() {
        this.status = this.$route.query.status;
        if(this.status == 1) {
          this.title = '设置家长隐私密码';
        } else if(this.status == 2) {
          this.title = '设置儿童隐私密码';
        } else if(this.status == 3) {
          this.flag = 1;
          this.show = true;
          this.title = '输入家长隐私密码';
        } else if(this.status == 4) {
          this.flag = 1;
          this.show = true;
          this.title = '输入儿童隐私密码';
        } else if(this.status == 5) {
          this.title = '修改家长隐私密码';
          this.text = '输入当前隐私密码';
          this.flag = 0;
        } else if(this.status == 6) {
          this.title = '修改儿童隐私密码';
          this.text = '输入当前隐私密码';
          this.flag = 0;
        } else if(this.status == 7) {
          this.title = '找回家长隐私密码';
          this.text = '输入登录密码';
          this.flag = 3;
          this.show = false;
        } else if(this.status == 8) {
          this.title = '找回儿童隐私密码';
          this.text = '输入登录密码';
          this.flag = 3;
          this.show = false;
        }
      },
        //返回上一页
        onClickLeft(){
            this.flag =1;
            this.firstList = [];
            this.secondList = [];
            this.oldPassword = [];
            this.text = '输入隐私密码';
		},
        //点击数字键盘
        onInput(value) {
            if(this.status == 1 || this.status == 2 || this.status == 7 || this.status == 8) {
                //设置密码
                if(this.firstList.length<5 && this.flag == 1) {
                    this.firstList.push(value);
                }

                if(this.secondList.length<5 && this.flag == 2) {
                    this.secondList.push(value);
                }
                if(this.firstList.length == 4) {
                    this.flag = 2;
                    this.text = '确认隐私密码';
                }
                if(JSON.stringify(this.firstList) == JSON.stringify(this.secondList) && this.secondList.length == 4) {
                    if(this.status == 1 || this.status == 7) {
                        this.setParentPassword();
                    } else {
                        this.setStudentPassword();
                    }
                } else if (this.secondList.length == 4 && this.firstList !== this.secondList) {
                    Toast('两次密码输入不一致,请重新输入');
                }
            } else if (this.status == 3 || this.status == 4) {
                //输入密码
                if(this.firstList.length<5 && this.flag == 1) {
                    this.firstList.push(value);
                }
                if(this.firstList.length == 4 && this.status == 3) {
                    this.checkParentPasswordEnable(this.firstList.toString());

                } else if(this.firstList.length == 4 && this.status == 4) {
                     this.checkStudentPasswordEnable(this.firstList.toString());
                }
            } else if(this.status == 5 || this.status == 6) {
                //修改密码
                if(this.oldPassword.length<5 && this.flag == 0) {
                    this.oldPassword.push(value);
                }
                if(this.firstList.length<5 && this.flag == 1) {
                    this.firstList.push(value);
                }

                if(this.secondList.length<5 && this.flag == 2) {
                    this.secondList.push(value);
                }
                if(this.oldPassword.length == 4 && this.status == 5) {
                    this.checkParentPasswordEnable(this.oldPassword.toString());
                }

                if(this.oldPassword.length == 4 && this.status == 6){
                    this.checkStudentPasswordEnable(this.oldPassword.toString())
                }
                if(this.firstList.length == 4) {
                    this.flag = 2;
                    this.text = '确认隐私密码';
                }
                if(JSON.stringify(this.firstList) == JSON.stringify(this.secondList) && this.secondList.length == 4) {
                    if(this.status == 5) {
                        this.setParentPassword();
                    } else {
                        this.setStudentPassword();
                    }
                } else if (this.secondList.length == 4 && this.firstList !== this.secondList) {
                    Toast('两次密码输入不一致,请重新输入');
                }
            }
        },
        //删除按钮
        onDelete() {
            if(this.flag == 1 && this.firstList.length>0) {
                this.firstList.pop();
            } else if (this.flag == 2 && this.secondList.length>0) {
                this.secondList.pop();
            } else if (this.flag == 0 && this.oldPassword.length>0) {
                this.oldPassword.pop();
            }
        },
        //输入登录密码失去焦点
        submit() {
            // this.login();
            let password = localStorage.getItem('userPassword');
            if(password == encryptBy(this.password)){
                this.flag =1;
                this.text = '输入隐私密码';
                this.show = true;
			}else {
				this.$toast('登录密码错误');
			}
        },
        //点击取消
        goOnce() {
            console.log(this.flag,this.status,this.routerFrom.name)
            if( this.flag == 1 && (this.status == 5 || this.status == 6) ) {
                this.flag = 0;
                this.firstList = [];
                this.secondList = [];
                this.oldPassword = [];
                this.text = '输入当前隐私密码';
            }else if(this.flag == 1 && (this.status == 7 || this.status == 8)) {
                this.flag = 3;
                this.firstList = [];
                this.secondList = [];
                this.oldPassword = [];
                this.password = '';
                this.text = '输入登录密码';
                this.show = false;
            } else if (this.flag == 3 && (this.status == 7 || this.status == 8)) {
              if (this.routerFrom.name == 'test-center') {
                if (this.status == 7) {
                  this.$router.replace({
                    path:'/privacyPassword',
                    query:{
                      status: '3'
                    }
                  })
                } else {
                  this.$router.replace({
                    path:'/privacyPassword',
                    query:{
                      status: '4'
                    }
                  })
                }
                this.reload();
              }
              if (this.routerFrom.name == 'privacy-management-detail') {
                this.$router.replace({
                  path: this.routerFrom.path,
                  query: {
                    title: this.routerFrom.query.title,
                    flag: this.routerFrom.query.flag
                  }
                });
              }
            } else {
              if (this.routerFrom.name == 'test-center') {
                this.$router.replace({
                  path: this.routerFrom.path
                })
              }
              if (this.routerFrom.name == 'privacy-management-detail') {
                this.$router.replace({
                  path: this.routerFrom.path,
                  query: {
                    title: this.routerFrom.query.title,
                    flag: this.routerFrom.query.flag
                  }
                });
              }
            }
        },
        //设置/修改家长隐私密码
        setParentPassword() {
            _setParentPassword({
                password: this.secondList.toString()
            }).then((res)=>{
                if(res && res.code==200){
                    Toast('设置成功');
                    setTimeout (()=>{
                        this.$router.push({
                            path:'/testType',
                            query:{
                                type: 1
                            }
                        })
                    },1000);
                }else{
                this.$toast(res.message)
                }
            })
        },
        //设置/修改儿童隐私密码
        setStudentPassword() {
            _setStudentPassword({
                password: this.secondList.toString(),
                userId: localStorage.getItem('childId')
            }).then((res)=>{
                if(res.code==200){
                    Toast('设置成功');
                    setTimeout (()=>{
                        this.$router.push({
                            path:'/testType',
                            query:{
                                type: 2
                            }
                        })
                    },1000);
                }else{
                this.$toast(res.message)
                }
            })
        },
        //检查家长隐私密码是否正确
        checkParentPasswordEnable(obj) {
            _checkParentPasswordEnable({
                password: obj
            }).then((res)=>{
                if(res.code==200){
                    if(res.data) {
                        if(this.status == 5) {
                            this.flag = 1;
                            this.text = '输入隐私密码';
                            this.oldPassword = [];
                        } else {
                            this.$router.push({
                                path:'/testType',
                                query:{
                                    type: 1
                                }
                            })
                        }
                    } else {
                        this.$toast('密码不对哦，若忘记密码可在设置页中找回。')
                    }

                }else{
                this.$toast(res.message)
                }
            })
        },
        //检查儿童隐私密码是否正确
        checkStudentPasswordEnable(obj) {
            _checkStudentPasswordEnable({
                password: obj,
                userId: localStorage.getItem('childId')
            }).then((res)=>{
                if(res.code==200){
                    if(res.data) {
                        if(this.status == 6) {
                            this.flag = 1;
                            this.text = '输入隐私密码';
                            this.oldPassword = [];
                        } else {
                            this.$router.push({
                                path:'/testType',
                                query:{
                                    type: 2
                                }
                            })
                        }
                    } else {
                        this.$toast('密码不对哦，若忘记密码可在设置页中找回。')
                    }

                }else{
                this.$toast(res.message)
                }
            })
        },
        handleGotoUpdatePwd() {
          if (this.status == '3') {
            // 找回家长密码
            this.$router.replace({
              path:'/privacyPassword',
              query:{
                status: '7'
              }
            })
          }
          if (this.status == '4') {
            // 找回儿童密码
            this.$router.replace({
              path:'/privacyPassword',
              query:{
                status: '8'
              }
            })
          }
          this.reload();
        },
        reload() {
          this.routerState = false;
          this.$nextTick(() => {
            this.init();
            this.routerState = true;
          });
        }
        //验证登录密码是否正确
        // login() {
        //     _login({
		// 		userName:this.phone,
		// 		smsCode:encryptBy(this.password),
		// 		origin:'C'
		// 	}).then((res)=>{
		// 		if(res.code && res.code==200){
        //             this.flag =1;
        //             this.text = '输入隐私密码';
        //             this.show = true;
		// 		}else {
		// 			this.$toast('登录密码错误');
		// 		}
		// 	})
        // }
    }
}
</script>
<style lang="scss" scoped>
    .privacyPassword {
        height: 100%;
        background: #eee;
        .privacyPassword_center {
            margin-top: 170px;
            .privacyPassword_center_circleBox {
                display: flex;
                .privacyPassword_center_circle {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    border: 2px solid #999999;
                    margin-left: 34px;
                }
                .privacyPassword_center_circle:nth-of-type(1) {
                    margin-left: 88.5px;
                }
                .active {
                    width: 20px;
                    height: 20px;
                    background: #FF8340;
                    border: none;
                }
            }
            p {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 22px;
                text-align: center;
                margin-top: 30px;
            }
            .privacyPassword_center_pass {
                width: 201px;
                margin-left: 87px;
                background: #F3F3F3;
                border-radius: 6px;
            }
            .privacyPassword_center_button {
                width: 110px;
                height: 30px;
                margin: 0 auto;
                background: linear-gradient(360deg, #FF7F30 0%, #FFBC97 100%);
                border-radius: 15px;
                line-height: 30px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                text-align: center;
                margin-top: 30px;
            }
        }
        .forgetPwd {
          position: fixed;
          right: 10px;
          bottom: 40%;
          text-align: right;
          font-size: 12px;
          font-weight: 400;
          color: #999;
        }
    }
    ::v-deep .van-icon {
        color: #000;
    }
    ::v-deep .van-ellipsis {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }
    .van-number-keyboard{
        background: #DDDFE5;
    }
    ::v-deep .van-key__wrapper:nth-child(10) {
        opacity: 0;
    }
    ::v-deep .van-key__wrapper:nth-child(12) .van-key{
         background: #DDDFE5;
    }
</style>
